const MailInvitation = () => {
  return (
    <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 8.55775L2 3.44225V13.6923C2 13.7821 2.02883 13.8558 2.0865 13.9135C2.14417 13.9712 2.21792 14 2.30775 14H11.25V15.5H2.30775C1.80258 15.5 1.375 15.325 1.025 14.975C0.675 14.625 0.5 14.1974 0.5 13.6923V2.30775C0.5 1.80258 0.675 1.375 1.025 1.025C1.375 0.675 1.80258 0.5 2.30775 0.5H17.6923C18.1974 0.5 18.625 0.675 18.975 1.025C19.325 1.375 19.5 1.80258 19.5 2.30775V9.25H18V3.44225L10 8.55775ZM10 7L17.8463 2H2.15375L10 7ZM16.8078 18.3943L15.7635 17.35L17.579 15.5H13.0578V14H17.5885L15.7385 12.15L16.8078 11.1058L20.452 14.75L16.8078 18.3943ZM2 3.44225V14.8365V9.25V9.373V2V3.44225Z" fill="#1D1F22"/>
</svg>
  )
}

export default MailInvitation
